"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAccountLevelTransactionsSortToJSON = exports.GetAccountLevelTransactionsSortFromJSONTyped = exports.GetAccountLevelTransactionsSortFromJSON = exports.GetAccountLevelTransactionsSort = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var GetAccountLevelTransactionsSort;
(function (GetAccountLevelTransactionsSort) {
    GetAccountLevelTransactionsSort["CreatedAt"] = "createdAt";
})(GetAccountLevelTransactionsSort = exports.GetAccountLevelTransactionsSort || (exports.GetAccountLevelTransactionsSort = {}));
function GetAccountLevelTransactionsSortFromJSON(json) {
    return GetAccountLevelTransactionsSortFromJSONTyped(json, false);
}
exports.GetAccountLevelTransactionsSortFromJSON = GetAccountLevelTransactionsSortFromJSON;
function GetAccountLevelTransactionsSortFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GetAccountLevelTransactionsSortFromJSONTyped = GetAccountLevelTransactionsSortFromJSONTyped;
function GetAccountLevelTransactionsSortToJSON(value) {
    return value;
}
exports.GetAccountLevelTransactionsSortToJSON = GetAccountLevelTransactionsSortToJSON;
